import qs from 'qs'
import moment from 'moment'
import omitBy from 'lodash/omitBy'
import isEmpty from 'lodash/isEmpty'
import isNumber from 'lodash/isNumber'
import pickBy from 'lodash/pickBy'

import { iso8601Format, dateTimeTimezoneFormat } from './timeHelper'

const stringsToNumbers = (search) => {
  const result = { ...search }
  for (let key in search) {
    if (!isNaN(search[key])) {
      result[key] = Number(search[key])
    }
  }
  return result
}

const displayDatesToRawDates = (search) => {
  const result = { ...search }
  for (let key in search) {
    if (moment(search[key], 'MM/DD/YYYYTHH:mm:ss', true).isValid()) {
      result[key] = iso8601Format(search[key])
    } else if (moment(search[key], 'MM/DD/YYYYTHH:mm:ss Z', true).isValid()) {
      result[key] = iso8601Format(search[key])
    }
  }
  return result
}

const rawDatesToDisplayDates = (search) => {
  const result = { ...search }
  for (let key in search) {
    if (moment(search[key], 'YYYY-MM-DDTHH:mm:ss Z', true).isValid()) {
      result[key] = dateTimeTimezoneFormat(search[key])
    }
  }
  return result
}

//PUBLIC FUNCTIONS
export const parseQueryForDisplay = (rawQuery) => {
  const parsed = qs.parse(rawQuery, { ignoreQueryPrefix: true, arrayLimit: 50 })
  const withNumbers = stringsToNumbers(parsed)
  return rawDatesToDisplayDates(withNumbers)
}

export const parseQuery = (rawQuery) => {
  const parsed = qs.parse(rawQuery, { ignoreQueryPrefix: true, arrayLimit: 50 })
  const withNumbers = stringsToNumbers(parsed)
  return displayDatesToRawDates(withNumbers)
}

export const stringifyQuery = (rawQuery) => {
  const trimEmptyValues = omitBy(rawQuery, isEmpty)
  const putNumbersBack = pickBy(rawQuery, isNumber)
  const trimmed = Object.assign({}, trimEmptyValues, putNumbersBack)
  const normalizeDates = displayDatesToRawDates(trimmed)
  return qs.stringify(normalizeDates)
}

export const convertStringToBoolean = (parsedQuery) => {
  const result = { ...parsedQuery }

  Object.entries(result).forEach(([key, value]) => {
    if (value === 'TRUE') {
      result[key] = true
    } else if (value === 'FALSE') {
      result[key] = false
    }
  })

  return result
}

export const toggleSort = (searchParams, sortEnum, defaultDirection) => {
  const realSearch = parseQuery(searchParams)
  const { direction } = realSearch

  if (direction === 'ASC') {
    const newSearch = Object.assign({}, realSearch, {
      sort: sortEnum,
      direction: 'DESC',
      offset: 0,
      limit: 25,
    })
    return qs.stringify(newSearch)
  } else if (direction === 'DESC') {
    const newSearch = Object.assign({}, realSearch, {
      sort: sortEnum,
      direction: 'ASC',
      offset: 0,
      limit: 25,
    })
    return qs.stringify(newSearch)
  } else {
    const newSearch = Object.assign({}, realSearch, {
      sort: sortEnum,
      direction: defaultDirection,
      offset: 0,
      limit: 25,
    })
    return qs.stringify(newSearch)
  }
}
